"use client";

import TestRunner from "@/components/teste/TestRunner";
import type { PublicTherapistSummary } from "@/actions/getTherapists";
import { traumaConfig, type TraumaCategory } from "@/data/tests/trauma";
import { captureTraumaLead, submitTraumaTest } from "./actions";

/**
 * The PCL-5 wired into the shared runner.
 *
 * A client component on purpose: the config holds functions, which a server
 * page cannot hand to a client component, so the config is imported here and
 * the page passes only the therapist list.
 */
export default function TraumaRunner({
  therapists,
}: {
  therapists: PublicTherapistSummary[];
}) {
  return (
    <TestRunner<TraumaCategory>
      config={traumaConfig}
      submit={submitTraumaTest}
      capture={captureTraumaLead}
      therapists={therapists}
      urgentCategories={["above_cutoff"]}
      zenyra={{
        /* The topic key Zenyra already has a prefill for. */
        topic: "trauma-si-ptsd",
        prefill: (score, category) => {
          const label =
            traumaConfig.bands.find((b) => b.category === category)?.label ?? category;
          return `Am facut testul PCL-5 pentru stres posttraumatic pe Mindtale si scorul meu este ${score}/80 (${label}). Vreau sa povestim despre ce inseamna pentru mine si cum pot continua.`;
        },
      }}
      emailCopy={{
        headline: "Vreau rezultatul pe email",
        body: "Îți trimitem scorul și explicația lui, ca să le ai la îndemână dacă vrei să vorbești cu un specialist. Fără spam, te dezabonezi oricând.",
        submitLabel: "Trimite-mi rezultatul",
      }}
    />
  );
}
